import React from 'react'

const i18nContext = React.createContext({});

export { i18nContext }
